import getBasePath from '../../../../common/functions/api-resource';
import genericActions from './generic-resource';

const basePath = getBasePath('api', 'tipo-investimento');
const basePathPlanejamento = getBasePath('planejamento', 'tipo-investimento');

const tipoInvestimentoActions = {
  ...genericActions(basePath),
  listarAtivos: { method: 'GET', url: `${basePath}?descInvestimento={nome}&indAtivo=true` },
  listarTiposLinhasInvestimentos: { method: 'GET', url: `${basePathPlanejamento}?colunaOrdenacao=desc_investimento` },
  listarLinhasInvestimentos: { method: 'GET', url: `${basePathPlanejamento}/{idTipoInvestimento}/linha-investimento` },
  ativarMassa: { method: 'PUT', url: `${basePath}/ativacao-massa` },
};

export default resource => resource(`${basePath}`, {}, tipoInvestimentoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/tipo-investimento.js